import websocket from "./modules/websocket";

const getters = {
  app: state => state.app.value, // get_version_info接口数据都在该变量里面

  ws: state => state.websocket.ws,
  message: state => state.websocket.message,
  authUrl: state => state.authUrl
}
export default getters
